"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _table = require("../../data/table");
var _dateHelper = require("../../../helpers/dateHelper");
var _numberFormatter = require("../../../helpers/numberFormatter");
var _orderHistoryHelper = require("../../../helpers/orderHistoryHelper");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _decimalPlacesHelper = require("../../../helpers/decimalPlaces/decimalPlacesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClass = (0, _cssClassesHelper.getBEMClasses)('order-history-table');
var OrderHistoryTradeReportsComponent = function OrderHistoryTradeReportsComponent(props) {
  var t = props.t,
    selectedAccountId = props.selectedAccountId,
    getOpenTradeReports = props.getOpenTradeReports,
    resetActivePage = props.resetActivePage,
    data = props.data,
    instruments = props.instruments,
    fetching = props.fetching,
    config = props.config,
    selectedInstrument = props.selectedInstrument;
  var maxLines = config.maxLines,
    usePagination = config.usePagination;
  (0, _react.useEffect)(function () {
    if (selectedAccountId) {
      getOpenTradeReports(selectedAccountId, props.OMSId, 0);
    }
    return function () {
      resetActivePage('OrderHistoryTradeReportsComponent');
    };
  }, [selectedAccountId, getOpenTradeReports, props.OMSId, resetActivePage]);
  var columns = (0, _react.useMemo)(function () {
    return [{
      header: t('Pair'),
      dataTest: 'Pair',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref) {
        var row = _ref.row;
        return row.original.instrument.Symbol;
      }
    }, {
      header: t('Side'),
      dataTest: 'Side',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref2) {
        var row = _ref2.row;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: baseClass(row.original.Side === 'Buy' ? 'buy' : 'sell')
        }, row.original.Side);
      }
    }, {
      header: t('Size'),
      dataTest: 'Size',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref3) {
        var row = _ref3.row;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: baseClass('size')
        }, row.original.Quantity && (0, _numberFormatter.formatNumberToLocale)(row.original.Quantity, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(row.original.selectedInstrument.QuantityIncrement)));
      }
    }, {
      header: t('Price'),
      dataTest: 'Price',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref4) {
        var row = _ref4.row;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: baseClass('price')
        }, (0, _orderHistoryHelper.getOrderPriceToDisplay)(row.original, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(row.original.selectedInstrument.PriceIncrement)));
      }
    }, {
      header: t('Fee'),
      dataTest: 'Fee',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref5) {
        var row = _ref5.row;
        return "".concat((0, _numberFormatter.formatNumberToLocale)(row.original.Fee, row.original.Fee.symbol), " ").concat(row.original.Fee.symbol);
      }
    }, {
      header: t('Date/Time'),
      dataTest: 'Date/Time',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref6) {
        var row = _ref6.row;
        return (0, _dateHelper.formatDateTime)(row.original.ReceiveTime || row.original.TradeTimeMS);
      }
    }, {
      header: t('Status'),
      dataTest: 'Status',
      meta: {
        textAlign: 'center'
      },
      cell: function cell() {
        return t('Complete');
      }
    }];
  }, [t]);
  var dataWithInstruments = data.map(function (row) {
    return _objectSpread(_objectSpread({}, row), {}, {
      selectedInstrument: selectedInstrument || instruments.find(function (item) {
        return item.InstrumentId === row.InstrumentId;
      }) || {}
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_table.Table, {
    className: baseClass(),
    columns: columns,
    data: dataWithInstruments,
    stickyColumns: {
      right: ['Actions']
    },
    loading: fetching,
    emptyMessage: t('No data is available'),
    pagination: (0, _react.useMemo)(function () {
      return usePagination ? {
        pageSize: maxLines,
        variant: 'simple'
      } : undefined;
    }, [usePagination, maxLines]),
    scrollable: true
  });
};
OrderHistoryTradeReportsComponent.propTypes = {
  data: _propTypes["default"].array.isRequired,
  instruments: _propTypes["default"].array.isRequired,
  config: _propTypes["default"].object.isRequired,
  cancelOrders: _propTypes["default"].func.isRequired
};
var OrderHistoryTradeReportsTranslated = (0, _reactI18next.withTranslation)('order')(OrderHistoryTradeReportsComponent);
// t('Trade Reports', { namespace: 'order' });
OrderHistoryTradeReportsTranslated.title = 'Trade Reports';
var _default = exports["default"] = OrderHistoryTradeReportsTranslated;